import { Link } from "react-router-dom";

const SECTIONS = [
  ["Titolare del trattamento",
   "Dishenda è la piattaforma gestionale per la ristorazione (di seguito \"Piattaforma\"). Per i dati dei clienti finali raccolti tramite prenotazioni, coupon e moduli pubblici, il Titolare del trattamento è il singolo ristorante che utilizza la Piattaforma; Dishenda opera come Responsabile del trattamento ai sensi dell'art. 28 GDPR, trattando i dati solo su istruzione del ristorante."],
  ["Dati trattati e finalità",
   "Per gli utenti della Piattaforma (ristoratori e staff): dati anagrafici, email, dati di fatturazione e log di utilizzo, trattati per l'erogazione del servizio (base giuridica: contratto). Per i clienti finali dei ristoranti: nome, contatti, preferenze di prenotazione e consensi marketing, trattati per conto del ristorante."],
  ["Sub-responsabili",
   "Invio email/SMS: Brevo (Sendinblue SAS, UE). Messaggi WhatsApp: Meta Platforms. Pagamenti: Stripe. Hosting: infrastruttura cloud UE. Ogni fornitore tratta i dati esclusivamente per conto del Titolare."],
  ["Conservazione",
   "Dati di prenotazione: 24 mesi. Consensi marketing: fino a revoca. Alla chiusura dell'account del ristorante i dati personali vengono eliminati o anonimizzati, conservando solo statistiche aggregate anonime."],
  ["Diritti dell'interessato",
   "Accesso, rettifica, cancellazione, limitazione, opposizione, portabilità e revoca del consenso: scrivi al ristorante (titolare) o a info@cavadaconsulting.it. Puoi sempre proporre reclamo al Garante per la protezione dei dati personali."],
  ["Minori",
   "Il servizio non è rivolto ai minori di 18 anni e non raccoglie consapevolmente loro dati."],
];

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 py-16 px-5" data-testid="privacy-page">
      <div className="max-w-2xl mx-auto">
        <Link to="/vetrina" className="text-xs text-zinc-500 hover:text-zinc-300 transition-colors">← dishenda.it</Link>
        <h1 className="font-display text-4xl font-extrabold tracking-tighter mt-4">Privacy Policy</h1>
        <p className="text-[11px] text-amber-400/90 bg-amber-400/10 border border-amber-400/20 rounded-md px-3 py-2 mt-4" data-testid="privacy-draft-note">
          Bozza standard — in fase di validazione legale. Ultimo aggiornamento: settembre 2026.
        </p>
        <div className="mt-8 space-y-7">
          {SECTIONS.map(([t, d]) => (
            <section key={t}>
              <h2 className="font-display font-bold text-lg text-zinc-100">{t}</h2>
              <p className="text-sm text-zinc-400 leading-relaxed mt-2">{d}</p>
            </section>
          ))}
        </div>
        <p className="text-xs text-zinc-600 mt-10">
          Vedi anche la <Link to="/cookie-policy" className="underline hover:text-zinc-400">Cookie Policy</Link>.
        </p>
      </div>
    </div>
  );
}
